module.exports = __webpack_public_path__ + "img/Rectangle 20.3f8a3e12.png";